import { REST_ENDPOINTS } from '@/config/api';
import { httpClient } from '@/lib/http-client';
import type { ShowcasePrices, ShowcasePricesParams } from '@/types/price';

type QueryValue = string | number | boolean | string[] | undefined | null;

function appendParam(params: URLSearchParams, key: string, value: QueryValue): void {
  if (value === undefined || value === null || value === '') {
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => {
      if (item !== undefined && item !== null && item !== '') {
        params.append(`${key}[]`, String(item));
      }
    });
    return;
  }

  params.append(key, String(value));
}

function buildUrl(baseUrl: string, entries: Record<string, QueryValue>): string {
  const params = new URLSearchParams();
  Object.entries(entries).forEach(([key, value]) => {
    appendParam(params, key, value);
  });
  const qs = params.toString();
  return qs ? `${baseUrl}?${qs}` : baseUrl;
}

export class PricesApi {
  static getShowcasePrices(params: ShowcasePricesParams): Promise<ShowcasePrices> {
    const url = buildUrl(REST_ENDPOINTS.PRICES, {
      productKind: params.productKind,
      facility: params.facility,
      productCode: params.productCode,
      startedAt: params.startedAt,
      promo: params.promo,
      showcase: params.showcase,
    });

    return httpClient.get<ShowcasePrices>(url, false);
  }
}
